import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Services from './pages/Services';
import Marketing from './pages/Marketing';
import Contact from './pages/Contact';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    // Initialize AOS animations matching original speed (800ms)
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);

  useEffect(() => {
    // Remove all page body classes to avoid overlap
    document.body.classList.remove(
      'page-index',
      'page-about',
      'page-portfolio',
      'page-services',
      'page-marketing',
      'page-contact'
    );

    // Add corresponding class based on current path
    const path = location.pathname;
    if (path === '/') {
      document.body.classList.add('page-index');
    } else if (path === '/about') {
      document.body.classList.add('page-about');
    } else if (path === '/signage') {
      document.body.classList.add('page-portfolio');
    } else if (path === '/services') {
      document.body.classList.add('page-services');
    } else if (path === '/marketing') {
      document.body.classList.add('page-marketing');
    } else if (path === '/contact') {
      document.body.classList.add('page-contact');
    }

    // Refresh AOS whenever route path changes to ensure new page sections animate
    AOS.refresh();
  }, [location]);

  return (
    <div className="App flex-layout">
      <Header />
      
      {/* Main Content Area */}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/signage" element={<Portfolio />} />
          <Route path="/services" element={<Services />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
